export const SUPPORT_MAIL = 'mailto:contest@rut-miit.ru';

export const SOCIAL_TG = 'https://t.me/edtechmiit';
export const SOCIAL_MAX =
	'https://max.ru/join/0oA2yx1C9vKFN0-iKxoV-Y1dccthqSy7ZqeFFDPXMv0';
export const SOCIAL_MAX_CHAT =
	'https://max.ru/join/UTAbZ-1jppUJiGGxtRP7Qg_zMUUtjIXU1d-w8n4KZ5Y';
export const SOCIAL_VK = 'https://vk.ru/edtechmiit';

export const REGULATION_LINK = 'https://cloud.mail.ru/public/DK9P/cgtKrx6Uk';
export const ORDER_LINK = 'https://cloud.mail.ru/public/EhNd/QJfdwYBAV';
export const PROTOCOL_LINK = '/protocol-stage-1.pdf';
export const PROTOCOL_SEMIFINAL_LINK = '/protocol-semifinal.pdf';
export const PERSONAL_DATA_POLICY_LINK = 'https://rut-miit.ru/org/privacy';
